import { Box, Button, Dialog, IconButton, Typography } from '@material-ui/core';
import { CustomTheme } from '@nemuru-eng/js-api-client';
import { useAuth } from '@nemuru-eng/providers';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ENV_DARK_MODE, ENV_ENV } from '@/config/envVars';
import { AppRole } from '@/config/types';
import { useUserContext } from '@/contexts/UserContext/UserContext';

import { APP_ROLES } from '../../../../config/config';
import { developOptions } from '../../../../config/developOptions';
import { LANGUAGES, REGISTRIES } from '../../../../config/languages';
import { getTheme } from '../../../../config/themes/getTheme';
import { useConfigContext } from '../../../../contexts/ConfigContext/ConfigContext';
import { Text } from '../Text';

// Not displaying all themes
const AVAILABLE_THEMES = [
  CustomTheme.NEMURU,
  CustomTheme.CAIXABANK,
  CustomTheme.TELEFONICA,
  CustomTheme.IBERIA,
  CustomTheme.IBERIA_CARDS,
  CustomTheme.THE_POWER,
  CustomTheme.QUADIS,
  CustomTheme.KTUIN,
  CustomTheme.DEMO,
];

export const isDevelopment = process.env.NODE_ENV === 'development';
export const isDevelopmentEnv = ENV_ENV === 'dev';

export function DevelopOptionsPanel() {
  const {
    state: { themeName, language, registry, showDevelopOptionsPanel, darkMode },
    actions: configActions,
  } = useConfigContext();

  const { updateUserContext } = useUserContext();
  const { logout } = useAuth();

  const navigate = useNavigate();

  const [layoutsDialog, setLayoutsDialog] = useState(false);

  // const [inputThemeValues, setInputThemeValues] = useState();
  // const handleChangeThemeInput = (event) => {
  //   setInputThemeValues(event.target.value);
  // };

  const nextRegistry =
    registry === REGISTRIES.default
      ? REGISTRIES.unbranded
      : registry === REGISTRIES.unbranded
      ? REGISTRIES.caixabank
      : registry === REGISTRIES.caixabank
      ? REGISTRIES.iberia
      : registry === REGISTRIES.iberia
      ? REGISTRIES.finanpay
      : REGISTRIES.default;

  const handleLogout = () => {
    logout();
    navigate('/');
    window.location.reload();
  };

  if (!isDevelopment && !isDevelopmentEnv && !showDevelopOptionsPanel) {
    return null;
  }

  return (
    <div>
      <Dialog open={layoutsDialog} maxWidth={'lg'}>
        <Box minHeight={600} p={3}>
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => setLayoutsDialog(false)}
            style={{
              position: 'fixed',
              margin: '-18px 0px 0 1420px',
            }}
          >
            <i className="material-icons-outlined" style={{ verticalAlign: 'text-top', fontSize: '24px' }}>
              close
            </i>
          </IconButton>
        </Box>
      </Dialog>
      <div
        className={'dev-opts-button'}
        style={{
          display: 'inline-block',
          margin: 'auto',
          zIndex: 999999,
          position: 'fixed',
          top: '20px',
          left: '20px',
        }}
      >
        <i
          className="material-icons-outlined"
          style={{
            color: darkMode ? '#fff' : '#000',
            fontSize: '23px',
            opacity: 0.2,
            position: 'absolute',
            zIndex: 4,
          }}
        >
          settings
        </i>
        <div
          style={{
            textAlign: 'center',
            margin: '-10px 0 0 -10px',
            border: '1px solid #000',
            borderRadius: '5px',
            padding: '20px',
            backgroundColor: darkMode ? '#000' : '#fff',
          }}
        >
          <Box pl={2} display="flex" flexDirection="column" alignItems={'flex-start'} gridGap={8}>
            <select
              name="ROLE"
              id="themeSelector"
              onChange={(e) => {
                updateUserContext({ roleOverride: e.target.value as AppRole });
              }}
              style={{ width: '100%' }}
            >
              {Object.values(APP_ROLES).map((role: AppRole) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </select>
            <select
              name="themes"
              id="themeSelector"
              value={themeName || ''}
              onChange={async (e) => {
                configActions.changeTheme(await getTheme(e.target.value as CustomTheme, darkMode));
              }}
              style={{ width: '100%' }}
            >
              {AVAILABLE_THEMES.map((themeName) => (
                <option key={themeName} value={themeName}>
                  {themeName}
                </option>
              ))}
            </select>
            <div>
              <input
                type="checkbox"
                checked={!!darkMode}
                onChange={async (e) => {
                  if (!themeName) return;
                  configActions.changeTheme(await getTheme(themeName as CustomTheme, e.target.checked));
                  localStorage.setItem(ENV_DARK_MODE, e.target.checked ? 'dark' : 'light');
                }}
              />
              <Typography variant="caption" color="textSecondary">
                Dark mode
              </Typography>
            </div>
            <div>
              <input
                type="checkbox"
                checked={developOptions.USE_FAKE_SERVICES_ON_POST_OR_PATCH}
                onChange={(e) => {
                  configActions.updateConfigContext({});
                  developOptions.USE_FAKE_SERVICES_ON_POST_OR_PATCH = e.target.checked;
                }}
              />
              <Typography variant="caption" color="textSecondary">
                Mock requests
              </Typography>
            </div>
            <div>
              <input
                type="checkbox"
                checked={developOptions.USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS}
                onChange={(e) => {
                  configActions.updateConfigContext({});
                  developOptions.USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS = e.target.checked;
                }}
              />
              <Typography variant="caption" color="textSecondary">
                Mock responses
              </Typography>
            </div>
            <div>
              <input
                type="checkbox"
                checked={developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES}
                onChange={(e) => {
                  configActions.updateConfigContext({});
                  developOptions.USE_FAKE_FORMS_AS_DEFAULT_VALUES = e.target.checked;
                }}
              />
              <Typography variant="caption" color="textSecondary">
                Mock forms
              </Typography>
            </div>
            <Button
              fullWidth
              size="small"
              variant="outlined"
              onClick={() => {
                configActions.setLanguage(
                  language === LANGUAGES.spanish
                    ? LANGUAGES.spanish
                    : language === LANGUAGES.english
                    ? LANGUAGES.english
                    : language === LANGUAGES.catalan
                    ? LANGUAGES.catalan
                    : // ? LANGUAGES.french
                      // : language === LANGUAGES.french
                      // ? LANGUAGES.german
                      LANGUAGES.spanish,
                );
              }}
            >
              <Text tId={'CHANGE_LANGUAGE'} />
            </Button>
            <Button
              fullWidth
              size="small"
              variant="outlined"
              onClick={() => {
                configActions.setRegistry(nextRegistry);
              }}
            >
              <Text tId={'CHANGE_REGISTRY'} /> <small> - ({registry})</small>
            </Button>
            <Button fullWidth size="small" onClick={handleLogout}>
              <Text tId={'LOGOUT'} />
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}
